import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-reset-password-dialog',
  templateUrl: './reset-password-dialog.component.html'
})

export class ResetPasswordDialogComponent {
  @Input() errorlist;
  @Input() type;
  @Output() doCancel = new EventEmitter();
  @Output() doContinue = new EventEmitter();

  constructor() { }

  cancel() {
    this.doCancel.emit();
  }

  continue() {
    this.doContinue.emit();
  }
}
